module.exports = __webpack_public_path__ + "2c59d93b8d62e8e69e187da58973e9c1.svg";